export default "__VITE_ASSET__B3xQW0Hc__"